const selectors = {
  select: '[data-nav-select]',
};

export const DropdownSelect = () => {
  const select = document.querySelector(selectors.select);
  select &&
    select.addEventListener('change', (event) => {
      window.location.href = event.target.value;
    });
};
